import React from "react";
import { FormProvider as Form } from "react-hook-form";

function FormProvider({ children, methods, onSubmit }) {
  return (
    <Form {...methods}>
      <form autoComplete="off" noValidate onSubmit={onSubmit}>
        {children}
      </form>
    </Form>
  );
}

export default FormProvider;
